const typography = {
  fontFamily: [
    'Montserrat',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
  ].join(','),
  h1: {
    fontWeight: 600,
    fontSize: '2.5rem',
    letterSpacing: '-0.24px',
  },
  h2: {
    fontWeight: 600,
    fontSize: '1.75rem',
    letterSpacing: '-0.24px',
  },
  h3: {
    fontWeight: 600,
    fontSize: '24px',
    letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.25rem',
    letterSpacing: '-0.06px',
  },
  h5: {
    fontWeight: 600,
    fontSize: '1rem',
    letterSpacing: '-0.05px',
  },
  h6: {
    fontWeight: 600,
    fontSize: '14px',
    letterSpacing: '-0.05px',
  },
  overline: {
    fontWeight: 600,
  },
  allVariants: {
    fontWeight: 500,
    color: '#354967',
  },
}

export default typography
